"use client";

import { useTranslations } from "next-intl";
import { Box, Image, Stack, Typography } from "@/components/controls/base-controls";
import { InstagramIcon, LinkedInIcon } from "@/components/controls/icons";
import SubscriberForm from "@/components/forms/subscriber.form";
import { WEBPAGE_CORE_CONTAINER } from "@/core/constants/webpages";
import { Link } from "@/i18n/navigation";

export default function Footer() {
  const t = useTranslations();

  return (
    <Box
      sx={{
        backgroundColor: "var(--mui-palette-darkest)",
        width: "100%"
      }}
    >
      <Stack sx={{
        margin: "0 auto",
        width: WEBPAGE_CORE_CONTAINER,
        maxWidth: "100%",
        display: "grid",
        padding: {xs: "2em 1em 3em", md: "4em 1em 5em"},
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gridTemplateAreas: { xs: `"bottom" "top"`, md: `"top bottom"` }
      }}>
        <Box sx={{ gridArea: 'bottom', mb: {xs: "3em", md: 0 }, display: "flex", justifyContent: { xs: "flex-start", md: "center" }, width: "100%" }}>
          <SubscriberForm />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            gap: { xs: "2em", md: "4em" },
            gridArea: 'top'
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-start",
              gap: ".25em",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: ".25em",
              }}
            >
              <Box
                sx={{
                  width: { xs: 53, md: 66 }, 
                  height: "auto",            
                  position: "relative", 
                }}
              >
                <Image
                  src="/images/logo.png"
                  alt="Navairra Logo"
                  loading="eager"
                  width={66}
                  height={47}
                  style={{
                    width: "100%",
                    height: "auto",
                    filter: "brightness(0) invert(1)"
                  }}
                />
              </Box>

              <Typography
                variant="companyName"
                sx={{
                  color: "var(--mui-palette-lightest)",
                }}
              >
                {t("company.name")}
              </Typography>
            </Box>

            <Typography
              variant="tagLine"
              sx={{
                color: "var(--mui-palette-lightest)",
                letterSpacing: "3px",
              }}
            >
              {t("company.slogan")}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              height: "100%",
              marginLeft: "3em",
            }}
          >
            <Stack sx={{
              direction: "column",
              alignItems: "flex-start",
              justifyContent: "flex-end",
            }}>
              <Box>
                <InstagramIcon sx={{ color: "var(--mui-palette-lightest)", marginRight: ".5em" }} />
                <LinkedInIcon  sx={{ color: "var(--mui-palette-lightest)" }}/>
              </Box>
              
              <Typography
                variant="footer"
                sx={{
                  marginY: ".3em",
                  color: "var(--mui-palette-lightest)"
                }}
              >
                <Link
                  href="/contact"
                  style={{
                    whiteSpace: "pre-line",
                    color: "var(--mui-palette-link-highlight)",
                  }}
                >
                  {t("footer.careers")}
                </Link>

                <Link
                  href="/contact"
                  style={{
                    whiteSpace: "pre-line",
                    color: "var(--mui-palette-link-highlight)",
                    marginLeft: "1em",
                  }}
                >
                  {t("footer.contact")}
                </Link>
              </Typography>

              <Typography
                variant="footer"
                sx={{
                  marginY: ".3em",
                  color: "var(--mui-palette-lightest)"
                }}
              >
                <Link
                  href="/terms"
                  style={{
                    whiteSpace: "pre-line",
                    color: "var(--mui-palette-link-highlight)",
                  }}
                >
                  {t("footer.terms")}
                </Link>

                <Link
                  href="/privacy"
                  style={{
                    whiteSpace: "pre-line",
                    color: "var(--mui-palette-link-highlight)",
                    marginLeft: "1em",
                  }}
                >
                  {t("footer.privacy")}
                </Link>
              </Typography>

              <Typography
                variant="footer"
                sx={{
                  paddingTop: ".25em",
                  color: "var(--mui-palette-lightest)",
                }}
              >
                {t("footer.copyright")}
              </Typography>

            </Stack>
          </Box>

        </Box>
      </Stack>
    </Box>
  );
}
